import { Copy } from "lucide-react";
import { Input } from "@/components/ui/input";
import { OptionSelect, FILL_LEVELS, CONDITIONS } from "@/components/WineFormSections";

export const EMPTY_COND = { fill_level: "", label_condition: "", capsule_condition: "", condition_other: "", serial_number: "" };
export const sizeConds = (conds, n) => Array.from({ length: Math.max(0, Math.min(Number(n) || 0, 500)) }, (_, i) => conds[i] || EMPTY_COND);

const Row = ({ i, c, onChange }) => {
  const set = (k) => (v) => onChange(i, { ...c, [k]: v });
  return (
    <div className="grid grid-cols-2 sm:grid-cols-[70px_1fr_1fr_1fr_1fr_1fr] gap-2 items-center" data-testid={`bottle-cond-row-${i}`}>
      <span className="font-mono text-xs text-[#D4AF37] col-span-2 sm:col-span-1">Bottle {i + 1}</span>
      <OptionSelect value={c.fill_level} onChange={set("fill_level")} options={FILL_LEVELS} placeholder="Fill level" testId={`bottle-cond-fill-${i}`} />
      <OptionSelect value={c.label_condition} onChange={set("label_condition")} options={CONDITIONS} placeholder="Label" testId={`bottle-cond-label-${i}`} />
      <OptionSelect value={c.capsule_condition} onChange={set("capsule_condition")} options={CONDITIONS} placeholder="Capsule" testId={`bottle-cond-capsule-${i}`} />
      <Input value={c.condition_other} onChange={(e) => set("condition_other")(e.target.value)} placeholder="Other" data-testid={`bottle-cond-other-${i}`} />
      <Input value={c.serial_number} onChange={(e) => set("serial_number")(e.target.value)} placeholder="Serial no." maxLength={60} data-testid={`bottle-cond-serial-${i}`} />
    </div>
  );
};

export const BottleConditionRows = ({ conds, setConds }) => {
  const change = (i, c) => setConds(conds.map((x, j) => (j === i ? c : x)));
  const copyFirst = () => setConds(conds.map((x) => ({ ...conds[0], serial_number: x.serial_number })));
  return (
    <div className="col-span-2 space-y-2" data-testid="bottle-conditions">
      <div className="flex items-center justify-between gap-3 pt-2">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">Bottle condition · one per bottle ({conds.length})</p>
        {conds.length > 1 && <button type="button" onClick={copyFirst} className="text-xs text-[#A89F91] hover:text-[#D4AF37] flex items-center gap-1" data-testid="bottle-cond-copy-first"><Copy className="w-3 h-3" />Same condition as bottle 1 for all</button>}
      </div>
      {!conds.length && <p className="text-xs text-[#6E665D]">Set the number of bottles to describe each one.</p>}
      <div className="space-y-2 max-h-80 overflow-y-auto pr-1">
        {conds.map((c, i) => <Row key={i} i={i} c={c} onChange={change} />)}
      </div>
    </div>
  );
};
